// extracted by mini-css-extract-plugin
export default {"news":"auth_news__FX0Xs","skeleton":"auth_skeleton__Y2F6H","overlay":"auth_overlay__dqMCI","info":"auth_info__ahB1A"};